<template>
  <div class="d-flex flex-column justify-content-between">
    <div class="d-flex flex-column">
      <!-- Card Infomation -->
      <div id="card-infomation">
        <b-card class="card-border-radius common-shadow noborder" body-class="body-landing">
          <div class="">
            <b-row cols="2" class="mt-1 pt-1">
              <b-col class="text-left text-align-self-start" cols="5">
                <span style="vertical-align: baseline"
                  class="font-kanit-regular-14 text-kanit-color-grey">หมายเลขใบสมัคร</span>
              </b-col>
              <b-col class="text-right px-0" cols="7" style="padding-right: 15px !important">
                <span class="font-kanit-regular-16-400 text-kanit-color-black" style="vertical-align: baseline">{{
                  userData.loanAppId }}</span></b-col>
            </b-row>
            <b-row cols="2" class="mt-1" style="line-height: 24px">
              <b-col class="text-left text-align-self-end px-0" style="
                  padding-left: 15px !important ;
                  line-height: 24px;
                  vertical-align: baseline;
                " cols="5">
                <span style="vertical-align: baseline"
                  class="font-kanit-regular-14 text-kanit-color-grey">อัปโหลดภายในวันที่</span>
              </b-col>
              <b-col class="text-right" cols="7">
                <span class="font-kanit-bold-16 text-kanit-color-black"
                  style="line-height: 24px; vertical-align: baseline">{{ covertExpiredDate(userData.expiredDate)
                  }}</span></b-col>
            </b-row>
            <b-row v-if="userData.expireDay <= 5" cols="2" class="mt-1" style="line-height: 24px">
              <b-col class="text-left" cols="6"> </b-col>
              <b-col class="text-right font-kanit-regular-16-400 text-kanit-color-danger">
                <span v-if="userData.expireDay > 1 && userData.expireDay <= 5">อีก {{ userData.expireDay }} วัน</span>
                <span v-else-if="userData.expireDay == 1">วันนี้วันสุดท้าย</span>
              </b-col>
            </b-row>
          </div>
          <div class="w-100 border-top-NEXT" style="margin-top: 16px; margin-bottom: 16px" />
          <b-row>
            <b-col>
              <span class="font-kanit-regular-14 text-kanit-color-grey">เตรียมเอกสารให้ครบถ้วนก่อนดำเนินการ</span>
            </b-col>
            <div class="w-100"></div>
            <b-col>
              <span class="font-kanit-regular-14 text-kanit-color-grey">หากคุณปิดหน้านี้
                <span class="font-kanit-bold-14 text-kanit-color-grey">เอกสารของคุณจะไม่ถูกบันทึก</span></span>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <!-- Document Required -->
      <div id="card-document-list" v-if="groupRequire.length > 0">
        <div class="pt-3">
          <span class="font-kanit-bold-18 text-kanit-color-black">เอกสารประกอบการสมัคร</span>
        </div>

        <div class="justify-content-md-center mt-3" v-for="(item, key) in groupRequire" :key="key">
          <template>
            <b-card class="card-border-radius common-shadow" body-class="body-landing" @click="
              item.doc_group_code == '01'
                ? goToDocumentGroup(item.doc_group_code, item.state)
                : ''
              " :class="checkBorderColor(item.state) === 'danger'
                ? 'card-danger'
                : checkBorderColor(item.state) === 'warning'
                  ? 'card-warning'
                  : 'noborder'
                ">
              <b-row style="line-height: 32px">
                <b-col cols="1" style="margin-top: 0.4vh">
                  <template v-if="item.state == 'attachfile'">
                    <b-iconstack font-scale="1.5">
                      <b-icon stacked icon="circle" style="color: var(--color-text-success)"></b-icon>
                      <b-icon stacked icon="check" style="color: var(--color-text-success)"></b-icon>
                    </b-iconstack>
                  </template>
                  <template v-else-if="item.state == 'success'">
                    <b-iconstack font-scale="1.5">
                      <b-icon stacked icon="circle-fill" style="color: var(--color-text-success)"></b-icon>
                      <b-icon stacked icon="check" style="color: #fff"></b-icon>
                    </b-iconstack>
                  </template>
                  <template v-else-if="item.state == 'error'">
                    <b-badge pill class="badge-wait badge-container object-center">
                      <span class="font-kanit-regular-14 object-center" style="line-height: 18px">
                        {{ key + 1 }}
                      </span>
                    </b-badge>
                  </template>
                  <template v-else-if="item.state == 'warning'">
                    <b-iconstack font-scale="1.5">
                      <b-icon stacked icon="circle-fill" style="color: var(--color-text-warning)"></b-icon>
                      <b-icon stacked icon="check" style="color: #fff"></b-icon>
                    </b-iconstack>
                  </template>
                  <template v-else>
                    <b-badge pill class="badge-wait badge-container object-center">
                      <span class="font-kanit-regular-14 object-center" style="line-height: 18px">
                        {{ key + 1 }}
                      </span>
                    </b-badge>
                  </template>
                </b-col>
                <b-col class="px-0 text-left" col style="
                    padding-left: 34px !important;
                    padding-right: 6% !important;
                  ">
                  <b-row align-v="center">
                    <b-col align-self="center">
                      <span class="font-kanit-bold-16" style="white-space: normal; word-break: break-word" :class="item.state != 'success'
                        ? 'text-kanit-color-black'
                        : 'text-revamp-color-after-success'
                        ">{{ item.doc_short_name }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="1" class="px-0" v-b-toggle="'my-collapse-' + item.doc_code"
                  style="line-height: 32px; padding-right: 32px !important">
                  <template v-if="item.doc_group_code != '01'">
                    <b-icon v-if="item.state != 'success'" icon="chevron-up" font-scale="1.3"
                      style="color: var(--color-primary); margin-bottom: 25%"
                      :class="item.collapse ? 'chevron-up' : 'chevron-down'" />
                  </template>
                  <template v-else>
                    <b-icon icon="chevron-right" font-scale="1.3" v-if="item.state != 'success'"
                      style="color: var(--color-primary); margin-bottom: 25%" />
                  </template>
                </b-col>
              </b-row>
              <b-row v-if="item.state != 'success'">
                <b-col cols="1" style="width: 34px !important"></b-col>
                <b-col style="padding-left: 34px !important">
                  <span class="font-kanit-regular-14" :class="item.state == 'overlimit'
                    ? 'text-kanit-color-danger'
                    : 'text-kanit-color-grey'
                    ">{{
                      item.state == "overlimit" ? "ขนาดเกินมา" : "เหลือพื้นที่"
                    }}
                    <b :class="item.state == 'overlimit'
                      ? 'text-kanit-color-danger'
                      : 'text-revamp-color-size-black'
                      ">{{
                        getFileSizeAndType(
                          Number(
                            item.filesReal.length > 0
                              ? Math.abs(item.totalFileSize)
                              : item.max_size * (1000 * 1000)
                          )
                        )
                      }}
                    </b>
                  </span>
                </b-col>
              </b-row>

              <template v-if="
                userData.followupStatus.code == 'RESUBMIT' &&
                item.reason_request != undefined &&
                item.reason_request != '' &&
                checkHistoryUpload(item.doc_code) &&
                ['overlimit', 'wait', 'attachfile'].includes(item.state) &&
                item.collapse
              ">
                <b-card class="card-border-radius noborder mt-3" style="background-color: #fff8f1"
                  body-class="body-landing">
                  <b-row>
                    <b-col cols="1" align-self="center">
                      <b-img center :src="revampIconResubmit" width="16" height="16" />
                    </b-col>
                    <b-col align-self="center">
                      <b class="text-kanit-color-orange-dark font-kanit-bold-14-600">{{ item.reason_request }}</b>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="1" align-self="center">
                      <b-col> </b-col>
                    </b-col>
                    <b-col align-self="start">
                      <span class="text-kanit-color-orange-dark font-kanit-regular-14">{{ item.reason_note }}</span>
                    </b-col>
                  </b-row>
                </b-card>
              </template>

              <b-row v-if="item.state == 'error'" class="pt-1">
                <b-col cols="1" style="width: 34px !important"></b-col>
                <b-col style="padding-left: 34px !important">
                  <span class="font-kanit-bold-14 text-kanit-color-danger">อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง</span>
                </b-col>
              </b-row>
              <b-row v-if="item.state == 'warning'" class="pt-2">
                <b-col cols="1" style="width: 34px !important"></b-col>
                <b-col style="padding-left: 34px !important">
                  <span class="font-kanit-bold-14 text-kanit-color-orange">อัปโหลดไม่สำเร็จ
                    กรุณาตรวจสอบและลองใหม่อีกครั้ง</span>
                </b-col>
              </b-row>
              <b-row v-if="item.state == 'success'">
                <b-col cols="1" style="width: 34px !important"></b-col>
                <b-col style="padding-left: 34px !important">
                  <span class="font-kanit-bold-14 text-revamp-color-success">อัปโหลดสำเร็จ</span>
                </b-col>
              </b-row>
              <template v-if="item.doc_group_code != '01' && item.state != 'success'">
                <div v-if="
                  item.state == 'error' ||
                  item.state == 'wait' ||
                  item.state == 'attachfile'
                " />
                <b-collapse :id="'my-collapse-' + item.doc_code" v-model="item.collapse" visible>
                  <b-row>
                    <b-col align-self="center">
                      <hr style="
                          height: 1px;
                          width: 100%;
                          background-color: #e5e7eb;
                        " />
                    </b-col>
                  </b-row>
                  <b-row class="pt-2">
                    <b-col align-self="center">
                      <componentMiniUpload :documentTypeObj="item" :viewRecommend="true" v-if="showSubmited()"
                        :callback="callbackSetStateDocumentType" :onReceiveNativeCommand="onReceiveNativeCommand" />
                    </b-col>
                  </b-row>
                </b-collapse>
              </template>
            </b-card>
          </template>
        </div>
      </div>

      <!-- Document Deviate -->
      <div class="mt-3" id="card-document-deviate-list" v-if="lstDocumentTypeDeviate.length > 0">
        <div>
          <b class="font-kanit-bold-18 text-kanit-color-black">เอกสารเพิ่มโอกาสพิจารณา (ไม่บังคับ)</b>
        </div>
        <div class="mt-3 justify-content-md-center">
          <b-card class="card-border-radius common-shadow noborder" body-class="body-landing py-3" :class="checkBorderColor(deviateState) === 'danger' ||
            checkBorderColor(deviateState) === 'warning'
            ? 'card-warning'
            : 'noborder'
            ">
            <b-row style="line-height: 32px" @click="
              deviateState != 'success' ? goToDocumentGroupDeviate() : ''
              ">
              <b-col cols="1" style="margin-top: 0.4vh">
                <template v-if="deviateState == 'error'">
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle-fill" style="color: var(--color-text-warning)"></b-icon>
                    <b-icon stacked icon="check" style="color: #fff"></b-icon>
                  </b-iconstack>
                </template>
                <template v-else-if="deviateState == 'warning'">
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle-fill" style="color: var(--color-text-warning)"></b-icon>
                    <b-icon stacked icon="check" style="color: #fff"></b-icon>
                  </b-iconstack>
                </template>
                <template v-else-if="deviateState == 'attachfile'">
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle" style="color: var(--color-text-success)"></b-icon>
                    <b-icon stacked icon="check" style="color: var(--color-text-success)"></b-icon>
                  </b-iconstack>
                </template>
                <template v-else-if="deviateState == 'success'">
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle-fill" style="color: var(--color-text-success)"></b-icon>
                    <b-icon stacked icon="check" style="color: #fff"></b-icon>
                  </b-iconstack>
                </template>
                <template v-else-if="
                  deviateState == 'wait' || deviateState == 'overlimit'
                ">
                  <b-badge pill class="badge-wait badge-container object-center">
                    <span class="font-kanit-bold-14 object-center" style="line-height: 18px">
                      {{ 1 }}
                    </span>
                  </b-badge>
                </template>
              </b-col>
              <b-col b-bad class="px-0 text-left" col style="padding-left: 34px !important">
                <b-row>
                  <b-col col style="line-height: 32px">
                    <b class="text-kanit-color-black font-kanit-bold-16" :class="deviateState != 'success'
                      ? 'text-kanit-color-black'
                      : 'text-revamp-color-after-success'
                      " style="font-size: 16px">เอกสารเพิ่มเติม</b>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="1" class="px-0" align-self="center"
                style="line-height: 32px; padding-right: 32px !important">
                <b-icon v-if="deviateState != 'success'" icon="chevron-right" font-scale="1.3"
                  style="color: var(--color-primary); margin-bottom: 25%" />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="1" style="width: 34px !important"></b-col>
              <b-col style="padding-left: 34px !important">
                <template v-if="deviateState != 'success'">
                  <span class="font-kanit-regular-14 text-kanit-color-grey">เหลือพื้นที่
                    <b class="text-revamp-color-size-black">
                      {{ sumMaxSizeByListDocumentType }}
                    </b>
                  </span>
                </template>
                <template v-else>
                  <span class="text-revamp-color-success font-kanit-bold-14">
                    อัปโหลดสำเร็จ
                  </span>
                </template>
                <b-row class="pt-2">
                  <b-col align-self="center" style="line-height: 16px" cols="12"
                    v-for="(item, key) in lstDocumentTypeDeviate" :key="key">
                    <b-row>
                      <b-col cols="1" style="margin-left: -1vw">
                        <b-icon icon="dot"></b-icon>
                      </b-col>
                      <b-col>
                        <p class="font-kanit-regular-14 text-kanit-color-grey"
                          style="white-space: normal; word-break: break-word">
                          {{ item.doc_short_name }}
                        </p>
                      </b-col>
                    </b-row>
                    <b-row v-if="
                      item.state == 'error' ||
                      (item.state == 'success' && deviateState != 'success')
                    ">
                      <b-col cols="1"> </b-col>
                      <b-col v-if="item.state == 'error'">
                        <p class="text-kanit-color-orange font-kanit-bold-14">
                          อัปโหลดไม่สำเร็จ กรุณาลองใหม่
                          อีกครั้งหรือข้ามการอัปโหลดเอกสารนี้
                        </p>
                      </b-col>
                      <b-col v-if="item.state == 'success'">
                        <p class="text-revamp-color-success font-kanit-bold-14">
                          อัปโหลดสำเร็จ
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </div>
    </div>
    <!-- Btn action -->
    <div>
      <!-- Deviate Card Infomation -->
      <b-card class="card-border-radius noborder mt-3" body-class="body-landing"
        style="background-color: rgba(214, 237, 255, 1) !important">
        <b-row class="d-flex">
          <b-col cols="1" class="d-flex">
            <b-col>
              <b-img :src="revampIconInfomation" width="16" height="16" class="mb-1" />
            </b-col>
          </b-col>
          <b-col class="d-flex">
            <span class="font-kanit-regular-14 text-kanit-color-grey ml-3" style="margin-top: 2px">
              การปลอมแปลงเอกสารมีผลต่อการพิจารณาสินเชื่อ
            </span>
          </b-col>
        </b-row>
      </b-card>
      <div style="padding-top: 32px; padding-bottom: 20px">
        <div v-if="showSubmited()">
          <b-row v-if="updateRender">
            <b-col>
              <button @click="doSubmit()" :class="'btn btn-block btn-submit-landing-page' +
                (isUpload ? ' btn-loading' : '')
                " type="button" style="line-height: 27px" :disabled="!validateState()">
                <span v-if="isUpload">กำลังอัปโหลดเอกสาร</span>
                <span v-else-if="firstSubmit()">อัปโหลดเอกสาร</span>
                <span v-else>อัปโหลดอีกครั้ง</span>
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <b-modal no-close-on-backdrop no-close-on-esc id="bv-modal-uploading" v-model="isUpload" hide-header
      hide-header-close hide-footer content-class="modal-content-custom"
      dialog-class="modal-custom-center modal-width-custom">
      <div class="justify-content-center text-center">
        <b-row class="justify-content-md-center">
          <b-col>
            <b-img-lazy :src="imgUploading" width="247" height="123" center></b-img-lazy>
          </b-col>
          <div class="w-100" />

          <b-col align-self="center"><b class="text-kanit-color-black font-kanit-bold-16">กำลังอัปโหลดเอกสาร
              <br />กรุณาอย่าปิดหน้านี้ หรือออกจากแอปฯ</b></b-col>
          <div class="w-100 py-1" />
          <b-col><span class="text-kanit-color-black font-kanit-regular-14">
              เมื่อสำเร็จแล้ว ระบบจะพาคุณเข้าสู่ขั้นตอนถัดไป</span>
          </b-col>
          <div class="w-100 py-1" />
          <b-col class="text-revamp-color-success font-kanit-bold-14">สำเร็จ {{ cnt_uploading }}/{{ cnt_max_uploading }}
            เอกสาร</b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  ErrorAlert,
  ErrorAlertHandler,
} from "@/utils/errorAlert/ErrorAlert.js";
import { getFileSize } from "@/utils/FileSize.js";
import { Warning } from "@/utils/popup/Warning.js";
import axios from "axios";

export default {
  components: {
    ComponentMiniUpload: () =>
      import("@/components/TemplateNewScreen/CommonMiniUpload.vue"),
  },
  data() {
    return {
      imgExpire: require("@/assets/images/foundationIllustrationContextualVayuApplicationFail@3x.png"),
      imgSwalErr: require("@/assets/images/foundationIllustrationGenericError@3x.png"),
      imgArrowRight: require("@/assets/images/foundationIconSimpleSystemArrowRight@3x.png"),
      iconUploadsError: require("@/assets/images/foundationIconSimpleObjectStatusesFailed.png"),
      iconUploadsSuccess: require("@/assets/images/foundationIconSimpleComponentSnackbarUploadSuccessGreen.png"),
      iconUploading: require("@/assets/images/foundationIconSimpleComponentSnackbarUpload.png"),
      iconUploadated: require("@/assets/images/foundationIconSimpleComponentSnackbarSuccessBlue.png"),
      imgArrowNone: require("@/assets/images/foundationIconSimpleSystemArrowRight.png"),
      imgUploading: require("@/assets/images/downloading.png"),
      revampIconInfomation: require("@/assets/images/revamp-information-ic.png"),
      revampIconResubmit: require("@/assets/images/revamp-resubmit-ic.png"),
      documentGroup: {},
      axiosInstance: null,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      maxsize: parseInt(process.env.VUE_APP_MAXSIZE),
      user: {},
      isUpload: false,
      updateRender: 1,
      countDocTypeUploading: 0,
      countDocTypeAttachfile: 0,
      urlapi: process.env.VUE_APP_APIURL,
      groupRequire: [],
      groupDeviate: [],
      docList: [],
      modalShow: false,
      errorDialogTitle: "",
      errorDialogMessage: "",
      errorDialogHeader: "",
      errorDialogImage: null,
      collapseList: [],
      deviateState: "wait",
      cnt_max_uploading: 0,
      cnt_uploading: 0,
      state: "PROCESS",
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    getHeight() {
      return window.innerHeight - 45;
    },
    lstDocumentTypeNotDeviate() {
      return this.documentType.filter((item) => !item.deviate_flag).sort();
    },
    lstDocumentTypeDeviate() {
      return this.documentType.filter((item) => item.deviate_flag).sort();
    },
    sumMaxSizeByListDocumentType() {
      let totalSize = 0;
      this.lstDocumentTypeDeviate.forEach((docType) => {
        const size = Number(
          docType.totalFileSize !== undefined &&
            docType.totalFileSize !== null &&
            !["error", "warning", "overlimit"].includes(docType.state) &&
            docType.filesReal.length > 0
            ? docType.totalFileSize
            : docType.max_size * (1000 * 1000)
        );
        totalSize += size;
      });
      return getFileSize(Number(totalSize));
    },
  },
  beforeUpdate() {
    this.updateFileUploading();
    this.groupRequire = this.lstDocumentTypeNotDeviate;
    this.deviateSetState();
  },
  mounted() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  created() {
    this.circuitBreaker = false;
    this.$event.$on("onExitCallback", () => this.alertExit());
    //inital listener
    // console.log("this.user.listener.landing", this.userData.listener);
    this.updateFileUploading();
    if (this.userData.listener) {
      this.$event.$on("onUploadCallback", (doctumentType) => {
        // console.log("onUploadCallback", doctumentType.doc_code);
        const docGroup = this.userData.document_group_type.find(
          (i) => i.grp_id == doctumentType.doc_group_code
        );
        this.$set(
          docGroup,
          "state",
          this.setStateGroupDocument(docGroup.grp_id)
        );
        this.updateRender += 1;
      });
      this.userData.listener = false;
      this.$store.dispatch("setUserData", this.userData);
    }
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      // console.error(err);
    }
    let currentMenu = {
      pageCode: "CommonLanding",
      pageName: "อัปโหลดเอกสาร",
      previousPage: "",
    };
    this.$event.$emit("update_current_menu", currentMenu);
    this.documentGroup = this.userData.document_group_type;
    this.documentType = this.userData.documentType;
    // console.log("created()");
    for (let item of this.documentGroup) {
      // console.log(item.grp_name, item.state);
      if (item.state == "wait" || item.state == "attachfile") {
        item.state = this.setStateGroupDocument(item.grp_id);
      }
      if (
        item.grp_id === "01" &&
        item.state != "success" &&
        item.state != "error"
      ) {
        item.state = this.setStateGroupDocument(item.grp_id);
      }
      if (item.lst_doc_id.length > 1) {
        this.checkStateDocumentGroupMoreThanOneDocId(item);
      }
      //regis collapseList
      this.collapseList.push({ grp_id: item.grp_id, visible: true });
    }
    let circuitBreaker = (action, value) => {
      if (action === "GET") {
        return this.circuitBreaker;
      } else if (action === "SET") {
        this.circuitBreaker = value;
      } else throw "ACTION MISSMATCH";
    };
    const fnSet = this.setIsLoading;
    const printErr = this.errorToString;
    this.axiosInstance = axios.create({
      baseURL: this.urlapi,
      timeout: this.timeout,
      headers: { Authorization: this.userData.token },
    });
    this.axiosInstance.interceptors.request.use(
      function (config) {
        fnSet(true);
        return config;
      },
      function (error) {
        console.error("Error from axios interceptor request", error);
        fnSet(false);
        // Do something with request error
        return Promise.reject(error);
      }
    );
    this.axiosInstance.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (!circuitBreaker("GET")) {
          console.error("Error from axios interceptor response", printErr(error));
          fnSet(false);
        }
        return Promise.reject(error);
      }
    );
    this.groupRequire = this.lstDocumentTypeNotDeviate;
    if (this.lstDocumentTypeDeviate.length > 0) {
      this.deviateSetState();
    }

    const event = {
      action: '',
      category: 'DGL_PT_FollowUpDocUpload',
      label: '',
      value: '',
    };
    this.sentGaTagging(event);
  },
  beforeDestroy() {
    this.$event.$off("onExitCallback");
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
  methods: {
    errorToString(error) {
      if (error instanceof Error) {
        const errorDetails = {
          message: error.message,
          name: error.name,
          code: error.code || 'N/A', // สำหรับ Axios error code
          config: error.config, // สำหรับ Axios request config
          stack: error.stack,
          // request: error.request
        };
        return JSON.stringify(errorDetails, null, 2);
      }
      return JSON.stringify(error, null, 2);
    },
    getFileSizeAndType(fSize) {
      return getFileSize(fSize);
    },
    handleVisibilityChange() {
      this.circuitBreaker = true;
      if (
        this.isHideScreen() &&
        this.isUpload &&
        ["PROCESS", "SAVE"].includes(this.state)
      ) {
        // console.log("User left the web view or minimized the app", this.state);
        this.alertExitScreen();
      }
    },
    isHideScreen() {
      return document.visibilityState === "hidden";
    },
    isVisibleScreen() {
      return document.visibilityState === "visible";
    },
    updateFileUploading() {
      if (this.isUpload !== undefined && !this.isUpload) {
        let arrayDocTypeUpload = this.userData.documentType.filter(
          (docType) =>
            docType.state == "attachfile" && docType.filesReal.length > 0
        );
        this.cnt_max_uploading = arrayDocTypeUpload.length;
      }
    },
    deviateSetState() {
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "error").length > 0
      ) {
        this.deviateState = "error";
        return;
      }
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "overlimit")
          .length > 0
      ) {
        this.deviateState = "overlimit";
        return;
      }
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "attachfile")
          .length > 0
      ) {
        this.deviateState = "attachfile";
        return;
      }
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "success")
          .length == this.lstDocumentTypeDeviate.length ||
        !this.showSubmited()
      ) {
        this.deviateState = "success";
        return;
      }
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "success").length >
        0
      ) {
        this.deviateState = "attachfile";
        return;
      }
      this.deviateState = "wait";
    },
    setIsLoading(value) {
      this.isUpload = value;
    },
    getDocumentGroup() {
      return this.documentGroup;
    },
    getDocumentType() {
      return this.documentType;
    },
    checkDocTypeIsSuccess(grpId, state) {
      if (this.firstSubmit()) return false;
      if ("01" === grpId && state !== "error") {
        let attachfile = this.checkDocument(grpId);
        let dStatement =
          this.userData.dStatementSelected != undefined &&
          this.userData.dStatementSelected;
        let ktbStatement =
          this.userData.accountSelected != undefined &&
          this.userData.accountSelected != "";

        if (attachfile || dStatement || ktbStatement) {
          return true;
        } else {
          return false;
        }
      }

      return state === "success";
    },
    goToDocumentGroup(grpId, state) {
      if (!this.showSubmited()) return;
      //check success
      if (this.checkDocTypeIsSuccess(grpId, state)) {
        console.log("docType state : " + state);
      }
      this.userData.grpId = grpId;
      this.$store.dispatch("setUserData", this.userData);
      let docList = [];
      this.listDoc = this.userData.document_group_type.find(
        (v) => v.grp_id == grpId
      );

      for (var i = 0; i < this.listDoc.lst_doc_id.length; i++) {
        for (var j = 0; j < this.userData.documentType.length; j++) {
          if (
            this.userData.documentType[j].doc_code == this.listDoc.lst_doc_id[i]
          ) {
            docList.push(this.userData.documentType[j]);
          }
        }
      }
      if (process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT == grpId) {
        this.$router.push({
          name: this.userData.routerPath.statement,
          params: { grpId: grpId, action: "NEXT" },
        });
      } else if (docList.length == 1 && docList[0].state != "deviate") {
        this.goToUploadPage(docList[0].doc_code, grpId);
      } else {
        this.$router.push({
          name: this.userData.routerPath.documentGroup,
          params: { grpId: grpId, action: "NEXT" },
        });
      }
    },
    showSubmited() {
      return ["PENDING", "SUBMITED", "RESUBMIT"].includes(
        this.userData.followupStatus.code
      );
    },
    checkDocument(grpId) {
      let docGroup = this.userData.document_group_type.find(
        (v) => v.grp_id == grpId
      );

      const docTypeBean = this.userData.documentType.filter(
        (docType) =>
          docGroup.lst_doc_id.includes(docType.doc_code) &&
          docType.filesReal.length > 0
      );
      return docTypeBean.length > 0;
    },
    setStateGroupDocument(grp_id) {
      let state;
      if (this.checkDocument(grp_id)) {
        state = "attachfile";
      } else {
        state = "wait";
      }

      if ("01" === grp_id) {
        let attachfile = this.checkDocument(grp_id);
        let dStatement =
          this.userData.dStatementSelected != undefined &&
          this.userData.dStatementSelected;
        let ktbStatement =
          this.userData.accountSelected != undefined &&
          this.userData.accountSelected != "";

        if (attachfile || dStatement || ktbStatement) {
          state = "attachfile";
        } else {
          state = "wait";
        }
      }
      // console.log(grp_id, state);
      return state;
    },
    async doSubmit() {
      try {
        if (this.validateState()) {
          this.checkTimeOut().then(() => {
            if (this.$swal.isVisible()) return;
            this.doSubmitImageProcessing();
            const event = {
              action: 'Click',
              category: 'DGL_PT_FollowUpDocUpload',
              label: 'DGL_PT_FollowUpDocUpload_Upload',
              value: '',
            };
            this.sentGaTagging(event);
          });
        } else {
          console.error("doSubmit else", err);
          ErrorAlert("2001", "1", this);
        }
      } catch (err) {
        console.error("doSubmit catch", err);
        ErrorAlert("9999", "1", this);
      }
    },
    firstSubmit() {
      let success = this.documentGroup.filter((i) => i.state == "success");
      let error = this.documentGroup.filter((i) => i.state == "error");
      return success.length == 0 && error.length == 0;
    },
    validateState() {
      //return false = disabled
      //return true = not disabled
      if (this.documentGroup.filter((i) => i.state == "error").length > 0)
        return false;
      let countDocTypeRequireAttachWithoutStatement =
        this.getDocumentType().filter(
          (i) =>
            (i.state == "attachfile" || i.state == "success") &&
            i.filesReal.length > 0 &&
            !i.deviate_flag &&
            i.doc_group_code !== process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT &&
            !i.filesReal.some(
              (item) =>
                item?.fileHavePassword &&
                item?.fileHavePassword == true &&
                item?.fileCheckassword != true
            )
        ).length;
      let countDocTypeRequire = this.getDocumentType().filter(
        (i) => !i.deviate_flag
      ).length;

      const docTypeStatement = this.getDocumentType().find(
        (d) => d.doc_group_code === process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      if (
        docTypeStatement !== undefined &&
        (docTypeStatement.filesReal.length > 0 ||
          (this.userData.accountSelected != undefined &&
            this.userData.accountSelected != ""))
      ) {
        countDocTypeRequireAttachWithoutStatement =
          countDocTypeRequireAttachWithoutStatement + 1;
      }
      return countDocTypeRequireAttachWithoutStatement >= countDocTypeRequire;
    },
    async doSubmitImageProcessing() {
      // console.log(">>>>>>> Start step save file");
      this.setIsLoading(true);
      let isError = false;
      this.updateRender += 1;
      this.cnt_max_uploading = 0;
      this.cnt_uploading = 0;
      let arrayDocTypeUploadIsDeviate = this.userData.documentType.filter(
        (docType) =>
          docType.state == "attachfile" &&
          docType.filesReal.length > 0 &&
          docType.deviate_flag
      );
      let arrayDocTypeUploadNotDeviate = this.userData.documentType.filter(
        (docType) =>
          docType.state == "attachfile" &&
          docType.filesReal.length > 0 &&
          !docType.deviate_flag
      );
      const arrayDocTypeUpload = arrayDocTypeUploadNotDeviate.concat(
        arrayDocTypeUploadIsDeviate
      );
      this.cnt_max_uploading = arrayDocTypeUpload.length;
      this.$forceUpdate();
      try {
        if (arrayDocTypeUpload.length > 0) {
          this.state = "SAVE";
          for (let docTypeItem of arrayDocTypeUpload) {
            if (
              docTypeItem.state == "attachfile" &&
              docTypeItem.filesReal.length > 0
            ) {
              const formData = this.getFormData(docTypeItem);
              await this.axiosInstance({
                method: "POST",
                url: "api/save",
                timeout: 600000,
                data: formData,
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
                .catch((error) => {
                  if (!this.circuitBreaker) {
                    if (error.code === 'ERR_NETWORK') {
                      console.error('เกิดข้อผิดพลาดในการเชื่อมต่อเครือข่าย', this.errorToString(error));
                      // แสดงข้อความแจ้งเตือนผู้ใช้
                      // เช่น "ไม่สามารถเชื่อมต่อได้ กรุณาตรวจสอบอินเทอร์เน็ตของคุณแล้วลองใหม่อีกครั้ง"
                    } else if (error.response) {
                      // กรณีที่เซิร์ฟเวอร์ตอบกลับมา แต่เป็น status code ที่ผิดพลาด (เช่น 404, 500)
                      console.error('เซิร์ฟเวอร์ตอบกลับมาพร้อมข้อผิดพลาด:', error.response.status);
                    } else {
                      // ข้อผิดพลาดอื่นๆ ที่เกิดตอนสร้าง request
                      console.error('เกิดข้อผิดพลาด:', this.errorToString(error));
                    }
                    docTypeItem.state = "error";
                    docTypeItem.filesReal = [];
                    isError = true;
                    this.handdleError(er);
                  } else {
                    this.setIsLoading(false);
                  }
                })
                .then((res) => {
                  if (res.data.status != "SUCCESS") isError = true;
                  this.mappingResponseSave(res, docTypeItem);
                });
              if (this.circuitBreaker) {
                // console.log(
                //   `circuitBreaker ${docTypeItem.doc_code}`,
                //   this.circuitBreaker
                // );
                isError = true;
              }
              if (isError) {
                break;
              }
            }
          }
          this.$store.dispatch("setUserData", this.userData);
          this.$forceUpdate();
          this.deviateSetState();
          // console.log("isError", isError);
          if (isError) {
            this.setIsLoading(false);
            this.circuitBreaker = false;
          } else {
            this.triggerSubmit();
          }
        }
        if (arrayDocTypeUpload.length == 0) {
          this.triggerSubmit();
        }
      } catch (error) {
        if (!this.circuitBreaker) {
          console.error(
            "error doSubmitImageProcessing catch ",
            this.errorToString(error)
          );
          ErrorAlert("9999", "1", this);
        } else {
          this.setIsLoading(false);
        }
      }
    },
    mappingResponseSave(res, docTypeItem) {
      // console.log("res", res);
      try {
        if (res.data.status == "SUCCESS") {
          this.cnt_uploading += 1;
          docTypeItem.state = "success";
          docTypeItem.collapse = false;
        } else if (res.data.status == "FAIL") {
          if (
            docTypeItem.doc_group_code ===
            process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT &&
            docTypeItem.filesReal.length > 0 &&
            this.userData.accountSelected != undefined &&
            this.userData.accountSelected.length > 0
          ) {
            docTypeItem.state = "warning";
          } else {
            docTypeItem.state = "error";
          }
          docTypeItem.filesReal = [];
        }
        this.$forceUpdate();
      } catch (e) {
        docTypeItem.state = "error";
        this.$forceUpdate();
      }
    },
    getFormData(docTypeObject) {
      let formData = new FormData();
      let password = [];
      if (docTypeObject.filesReal !== undefined) {
        docTypeObject.filesReal.forEach((f) => {
          if (f.file !== undefined) {
            if (f.uploadType === undefined || f.uploadType === "") {
              formData.append(f.type, f.file);
            } else {
              formData.append(f.type + "_" + f.uploadType, f.file);
            }
          }
          if (!f.fileHavePassword && f.password != undefined) {
            password.push(f.file.name + "|" + f.password);
          }
        });
      }
      formData.append("doc_code", docTypeObject.doc_code);
      if (password.length > 0) formData.append("lst_password", password);
      return formData;
    },
    getFormDeviateData() {
      if (this.circuitBreaker) {
        // console.log(`circuitBreaker step trigger`);
        this.setIsLoading(false);
        return;
      } else {
        let grp01 = this.userData.document_group_type.find(
          (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
        );
        let docIdStatement;
        if (grp01 !== undefined) {
          docIdStatement = grp01.lst_doc_id[0];
        }

        let lstDeviate = [];

        this.userData.documentType.forEach((i) => {
          if (
            i.deviate_flag &&
            (i.filesReal == undefined || i.filesReal.length == 0)
          ) {
            lstDeviate.push(i.doc_code);
            i.state = "deviate";
          }
          if (
            i.doc_code == docIdStatement &&
            (i.filesReal == undefined || i.filesReal.length == 0)
          ) {
            lstDeviate.push(i.doc_code);
            i.state = "success";
          }
        });

        this.$forceUpdate();
        return {
          lstDeviate: lstDeviate,
          accountLst:
            this.userData.accountSelected != undefined
              ? this.userData.accountSelected
              : [],
          dStatementFlag:
            this.userData.dStatementSelected != undefined
              ? this.userData.dStatementSelected
              : false,
          docIdStatement: docIdStatement,
        };
      }
    },
    async checkTimeOut() {
      let response;
      response = await this.axiosInstance({
        method: "GET",
        url: "api/checkTimeout",
        timeout: this.timeout,
      })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error("checkTimeout", error);
          if (this.userData.channel == "WEB") {
            this.$store.dispatch("clearUserData");
          }
          this.handdleError(error);
          return response;
        });
      return response;
    },
    async sendUploads(formData) {
      this.state = "UPLOAD";
      this.axiosInstance({
        method: "POST",
        url: "/api/upload",
        data: formData,
      })
        .then((res) => {
          if (res.data.status) {
            const fn = this.setIsLoading;
            this.userData.followupStatus = {
              code: "COMPLETE",
              desc: "Pending for Approval",
              name: "คำขออยู่ระหว่างการพิจารณา",
            };
            this.$store.dispatch("setUserData", this.userData);
            this.$forceUpdate();
            try {
              this.$callback.openLFMProductionShelfWithLoanAppID(
                this.userData.loanAppId
              );
            } catch (err) {
              console.error(err);
            }
            // this.setIsLoading(true);
            setTimeout(function () {
              fn(false);
            }, 10000);
          } else {
            if (
              res.data.errorList !== undefined &&
              res.data.errorList.length > 0
            ) {
              res.data.errorList.forEach((doc_error) => {
                this.userData.documentType.forEach((j) => {
                  if (j.doc_code == doc_error.docCode) {
                    this.$set(j, "state", "error");
                    if (
                      process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT ===
                      j.doc_group_code &&
                      docTypeStatement.filesReal.length > 0 &&
                      this.userData.accountSelected != undefined &&
                      this.userData.accountSelected != ""
                    ) {
                      this.$set(j, "state", "warning");
                    }
                  }
                });
              });
              this.$forceUpdate();
              this.deviateSetState();
            } else {
              console.error("error sendUploads else else", res.data);
              ErrorAlert(res.data.code, "1", this);
            }
          }
        })
        .catch(async (error) => {
          console.error("error sendUploads catch", error);
          if (!this.circuitBreaker) {
            this.handdleError(error);
          } else {
            this.circuitBreaker = false;
            if (!error.response || error.response.status === 0) {
              // Retry logic
              // console.log("Network error detected. Retrying...");
              setTimeout(() => this.sendUploads(formData), 500);
            }
          }
        });
    },
    closeWeb(callDocTum) {
      // console.log(">>>>>>> Start step redirect");
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement = "";
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }
      this.axiosInstance({
        method: "GET",
        url: process.env.VUE_APP_PATH_CLOSE_WEB,
        params: {
          callDocTum: callDocTum,
          dStatementFlag:
            this.userData.dStatementSelected != undefined
              ? this.userData.dStatementSelected
              : false,
          docIdStatement: docIdStatement,
        },
      })
        .then((response) => {
          const fn = this.setIsLoading;
          if ("Y" == response.data) {
            this.userData.followupStatus = {
              code: "COMPLETE",
              desc: "Pending for Approval",
              name: "คำขออยู่ระหว่างการพิจารณา",
            };
            this.$store.dispatch("setUserData", this.userData);
            this.$forceUpdate();
            try {
              this.$callback.openLFMProductionShelfWithLoanAppID(
                this.userData.loanAppId
              );
            } catch (err) {
              console.error(err);
            }
          }
          // this.setIsLoading(true);
          setTimeout(function () {
            fn(false);
          }, 10000);
        })
        .catch((error) => {
          console.error("error send close web catch", error);
          if (!this.circuitBreaker) {
            this.handdleError(error);
          } else {
            this.circuitBreaker = false;
            if (!error.response || error.response.status === 0) {
              // Retry logic
              // console.log("Network error detected. Retrying...");
              setTimeout(() => this.closeWeb(callDocTum), 500);
            }
          }
        });
    },
    handdleError(error) {
      console.error("handdleError", error.message);
      this.$forceUpdate();
      this.setIsLoading(false);
      ErrorAlertHandler(error, 1, this);
    },
    triggerSubmit() {
      try {
        if (this.circuitBreaker) {
          // console.log(`circuitBreaker step trigger`);
          this.setIsLoading(false);
          return;
        } else {
          if (
            this.getDocumentGroup().filter((d) => d.state == "error").length > 0
          )
            return;
          let data = this.getFormDeviateData();
          if (data) {
            this.sendUploads(data);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    setStateDocumentGroup() {
      let arrayGroup = this.documentGroup.filter((i) => i.state == "uploading");
      arrayGroup.forEach((docGroup) => {
        let array = this.userData.documentType.filter(
          (docType) =>
            docGroup.lst_doc_id.includes(docType.doc_code) &&
            docType.state == "error"
        );
        if (array.length == 0) {
          docGroup.state = "success";
        } else {
          docGroup.state = "error";
          docGroup.errorMsg = "อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
        }
      });
      this.$forceUpdate();
    },
    checkDisplayGroupDeviate(item) {
      if (this.firstSubmit()) return true;
      if (
        item.state == "success" ||
        item.state == "error" ||
        item.state == "attachfile"
      )
        return true;
      return false;
    },
    goToUploadPage(doc_code, grpId) {
      this.$router.push({
        name: this.userData.routerPath.upload,
        params: { doc_code: doc_code, grpId: grpId },
      });
    },
    checkStateDocumentGroupMoreThanOneDocId(documentGroup) {
      let attachComplete = false;
      documentGroup.lst_doc_id.forEach((d) => {
        const data = this.documentType.find(
          (e) => e.doc_code == d && !e.deviate_flag
        );
        if (
          data !== undefined &&
          data.filesReal != undefined &&
          data.filesReal.length > 0
        ) {
          attachComplete = true;
        } else if (documentGroup.deviate_flag) {
          const data = this.documentType.find(
            (e) => e.doc_code == d && e.deviate_flag
          );
          if (
            data !== undefined &&
            data.filesReal != undefined &&
            data.filesReal.length > 0
          ) {
            attachComplete = true;
          }
        }
      });
      documentGroup.state = attachComplete ? "attachfile" : "wait";
    },
    covertExpiredDate(date) {
      return (
        date.substring(0, date.length - 2) +
        " 25" +
        date.substring(date.length - 2, date.length) +
        " - 23:59"
      );
    },
    checkBorderColor(state) {
      if (state == "error" || state == "overlimit") return "danger";
      if (state == "warning") return "warning";
    },
    callbackSetStateDocumentType(docType) {
      // console.log("docType", docType);
      try {
        let docBean = this.userData.documentType.find(
          (d) => d.doc_code == docType.doc_code
        );
        docBean.filesReal = docType.filesReal;
        docBean.state = docType.state;
        docBean.totalFileSize =
          Number(docType.max_size) * (1000 * 1000) -
          Number(docType.filesRealSize);
        if (docBean.totalFileSize < 0) {
          docBean.state = "overlimit";
        }
        this.$forceUpdate();
        this.$store.dispatch("setUserData", this.userData);
      } catch (er) {
        console.error(er);
      }
    },
    goToDocumentGroupDeviate() {
      const event = {
        action: 'Click',
        category: 'DGL_PT_FollowUpDocUpload',
        label: 'DGL_PT_FollowUpDocUpload_AdditionalDoc',
        value: '',
      };
      this.sentGaTagging(event);
      this.$router.push({
        name: this.userData.routerPath.preupload,
        params: {
          grpId: "deviate",
          action: "NEXT",
          docList: this.lstDocumentTypeDeviate,
        },
      });
    },
    alertExit() {
      let event = {
        action: 'Click',
        category: 'DGL_PT_FollowUpDocUpload',
        label: 'DGL_PT_FollowUpDocUpload_Close',
        value: '',
      };
      this.sentGaTagging(event);

      Warning(
        {
          title: "ยกเลิกการอัปโหลดเอกสาร?",
          message:
            "หากยกเลิก ข้อมูลของคุณจะไม่ถูกบันทึก<br />และต้องเลือกเอกสารใหม่อีกครั้ง",
          confirmButtonText: "ใช่",
          cancelButtonText: "ไม่ใช่",
          confirmCallBack: () => {
            event = {
              action: 'Click',
              category: 'DGL_PT_FollowUpDocUpload',
              label: 'DGL_PT_FollowUpDocUpload_Close_CF',
              value: '',
            };
            this.sentGaTagging(event);
            this.goToExitEntryPoint();
          },
          cancelCallBack: () => {
            event = {
              action: 'Click',
              category: 'DGL_PT_FollowUpDocUpload',
              label: 'DGL_PT_FollowUpDocUpload_Close_CC',
              value: '',
            };
            this.sentGaTagging(event);
          }
        },
        this.$swal
      );
    },
    goToExitEntryPoint() {
      try {
        this.$callback.openLfmStatusPage();
      } catch (err) {
        console.error(err);
      }
    },
    alertExitScreen() {
      Warning(
        {
          state: "error",
          title: "ไม่สามารถอัปโหลดเอกสารได้",
          message:
            "เนื่องจากคุณออกจากแอปฯ<br />ขณะกำลังอัปโหลดเอกสาร<br />กรุณาอัปโหลดเอกสารใหม่อีกครั้ง",
          confirmButtonText: "ตกลง",
          confirmCallBack: () => {
            window.location.href = `/upload?authorizationCode=${this.userData.token}&redirect=Y`;
          },
        },
        this.$swal
      );
    },
    checkHistoryUpload(docCode) {
      let history = this.userData.historyUploads.find(
        (i) => i.doc_code == docCode
      );
      return history.doc_upload_date !== null;
    },
    onReceiveNativeCommand(doc_code) {
      window["onReceiveNativeCommand"] = (commandName, payload) => {
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;
        console.log("commandName: ", commandName, "  value: ", payload);
        if (commandName == "openCamera") {
          if (isAndroid) {
            document.getElementById("fileCamera_" + doc_code).click();
          } else {
            document.getElementById("fileBrowseIOS_" + doc_code).click();
          }
        } else if (commandName == "openGallery") {
          if (isAndroid) {
            document.getElementById("fileBrowseImage_" + doc_code).click();
          } else {
            document.getElementById("fileBrowseIOS_" + doc_code).click();
          }
        }
      };
      return true;
    },
    sentGaTagging(event){
      if("1115" == this.userData.marketCode && "7002" == this.userData.productType){
        const product = {
          key: "product_type",
          value: "DL_SMARTMONEY"
        }
        const dimension = [product];
        try {
          this.$callback.gaTagging(event, dimension);
        } catch (err) {
          console.error("GA Tagging error", err);
        }
      }

    },
  },
};
</script>
<style scoped>
.row-card-landing {
  padding-left: 14px;
  padding-right: 14px;
}

.body-landing {
  padding-left: 1rem;
  padding-right: 1rem;
}

.progress-bar-custom {
  height: 3px;
  border-radius: unset;
  border-bottom-left-radius: 60px 27px;
  border-bottom-right-radius: 60px 27px;
  margin-left: 2.5px;
  margin-right: 2.5px;
  background-color: unset;
}

.status-color-001 {
  color: #479e6a !important;
}

.status-color-002 {
  color: #df0747 !important;
}

.status-color-003,
.status-color-004 {
  color: #daa60b !important;
}

.status-color-PENDING,
.status-color-RESUBMIT {
  color: #df0747 !important;
}

.status-color-SUBMITED,
.status-color-SUBMITED2,
.status-color-COMPLETE {
  color: #479e6a !important;
}

.badge-primary {
  border: 1.5px solid #33c5ff;
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: #33c5ff;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.badge-wait {
  border: 1.5px solid #c2d0d9 !important;
  box-sizing: border-box;
  margin: -10px -10px;
  margin-top: 0rem;
  color: #c2d0d9 !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
  margin-left: 1%;
}

.text-danger {
  color: rgb(219, 0, 0);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}

.text-resubmit {
  color: rgb(212, 150, 74);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}
</style>
<style>
.text-loan-info {
  color: black !important;
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
}

.text-label {
  color: #727a8d !important;
  font-size: 14px;
}

.position-footer {
  position: fixed;
  bottom: 0;
  margin-bottom: 10%;
}

.content-card-sm {
  min-height: 45vh;
}

.content-card-md {
  min-height: 55vh;
}

.btn-loading {
  color: rgb(145, 159, 169) !important;
  background-color: rgb(231, 235, 240) !important;
  border-color: rgb(231, 235, 240) !important;
  background-image: none !important;
}

.swal2-htmlContainer-next-fullscreen {
  font-size: 16px !important;
  margin-bottom: 25vh !important;
  margin-top: 1rem !important;
  line-height: 24px !important;
  height: 50% !important;
}

.swal2-image-next-fullscreen {
  margin-top: 10vh !important;
  margin-bottom: 10vh !important;
}

.swal2-icon {
  border-color: unset !important;
  border: unset !important;
  line-height: 20px !important;
  width: 100% !important;
  margin: 0px !important;
  align-items: unset !important;
}

.swal2-icon-content {
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
  color: black !important;
  font-size: 20px !important;
}

.swal2-modal-next-fullscreen {
  border-radius: 0px !important;
  width: 100% !important;
  padding: 24px !important;
  height: 100vh !important;
  -webkit-animation: unset !important;
  animation: unset !important;
}

.swal2-actions-next-fullscreen {
  display: flex !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  margin-right: 0px !important;
  margin-bottom: 35px !important;
  margin-left: 0px !important;
}

.chevron-rotateX {
  transform: rotateZ(90deg);
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.chevron-rotateY {
  transform: rotateY(0deg);
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.card-revamp {
  border: none;
  border-radius: 32px !important;
  box-shadow: 0px 2px 6px 0px rgba(209, 213, 219, 0.3);
}

.text-revamp-grey {
  color: rgba(107, 114, 128, 1);
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0px;
}

.text-revamp-dark-grey {
  color: rgba(17, 25, 40, 1);
}

.text-revamp-bold {
  font-weight: 600;
}

.text-revamp-bold-16 {
  color: rgba(17, 25, 40, 1);
  font-weight: 600;
  font-size: 16px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #111928b2 !important;
  animation: opacityShow 0.3s ease-in forwards !important;
}

@keyframes opacityShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
